
@if (hasPicture()) {
  <img class="avatar" [src]="getSanitizedUrl()" [alt]="name">
}
@if (!hasPicture()) {
  <ng-container #initiales>
    <i class="icon icon-user avatar" ></i>
  </ng-container>
}
